import utils from "@/stuff/Utils";
import { mapData } from "@/stuff/DataMapping";

export interface IScope {
    id: number;
    description: string;
    created: Date;
    createdByUserID: number;
    lastUpdated: Date;
    lastUpdatedByUserID: number;
    deleted: Date;
    deletedByUserID: number;
}

export class Scope implements IScope {

    constructor(data?: IScope) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IScope) {
        mapData(data, { root: () => this });
    }

    id: number = 0;
    description: string = "";
    created: Date = new Date(utils.emptyDateValue);
    createdByUserID: number = 0;
    lastUpdated: Date = new Date(utils.emptyDateValue);
    lastUpdatedByUserID: number = 0;
    deleted: Date = new Date(utils.emptyDateValue);
    deletedByUserID: number = 0;

    get isNew() {
        return utils.isEmptyId(this.id);
    }

    get isDeleted() {
        return utils.hasDateValue(this.deleted);
    }
}
